<template>
  <div class="text-center" :class="small ? 'py-4' : 'py-5'" role="status" aria-live="polite">
    <b-spinner variant="primary" small />
    <span class="ms-2 text-muted small">{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: "LoadingState",
  props: {
    message: { type: String, required: true },
    // Compact vertical spacing for nested panels and modals
    small: { type: Boolean, default: false },
  },
};
</script>
